var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.homeComponent,_vm._b({tag:"component",on:{"signin":function($event){return _vm.$emit('signin')}}},'component',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }